import { render, staticRenderFns } from "./InventoryHistoryComponent.vue?vue&type=template&id=75b8cca8"
import script from "./InventoryHistoryComponent.vue?vue&type=script&lang=js"
export * from "./InventoryHistoryComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports